// extracted by css-extract-rspack-plugin
export default {"editor_table":"XGtFRKV4xnE5VdUr"};